import { Box, Skeleton } from '@mui/material'
import { useEffect, useState } from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { KeyVisualModel } from '~/features/popup/hooks/createModel'
import { useIntersection } from '~/hooks/useIntersection'
import { KeyVisual } from './KeyVisual'
import { KeyVisualsCarouselArrow } from './KeyVisualsCarouselArrow'

interface KeyVisualsCarouselProps {
  keyVisuals: KeyVisualModel[]
  onClickThumbnail: (keyVisual: KeyVisualModel) => void
  onSlideShown?: (keyVisual: KeyVisualModel) => void
}

export const KeyVisualsCarousel = ({
  keyVisuals,
  onClickThumbnail,
  onSlideShown,
}: KeyVisualsCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const { observedRef, isIntersecting } = useIntersection()
  const currentKeyVisual = keyVisuals[currentIndex]

  useEffect(() => {
    if (!isIntersecting || !currentKeyVisual) return
    onSlideShown?.(currentKeyVisual)
  }, [isIntersecting, currentKeyVisual, onSlideShown])

  const slides =
    keyVisuals.length > 0
      ? keyVisuals.map((keyVisual, index) => (
          <KeyVisual
            key={index}
            keyVisual={keyVisual}
            onClickThumbnail={() => onClickThumbnail(keyVisual)}
          />
        ))
      : [1].map(() => (
          <Box height={{ sm: '448px' }} sx={{ aspectRatio: { xs: '16 / 7', sm: 'auto' } }}>
            <Box position='relative' width='100%' height='100%'>
              <Skeleton variant='rectangular' width='100%' height='100%' />
            </Box>
          </Box>
        ))

  return (
    <div ref={observedRef}>
      <Carousel
        showStatus={false}
        infiniteLoop
        showThumbs={false}
        onChange={setCurrentIndex}
        renderArrowPrev={(clickHandler) => (
          <KeyVisualsCarouselArrow onClickArrow={clickHandler} type='prev' />
        )}
        renderArrowNext={(clickHandler) => (
          <KeyVisualsCarouselArrow onClickArrow={clickHandler} type='next' />
        )}
      >
        {slides}
      </Carousel>
    </div>
  )
}
